<template>
  <div class="saerch-ad-description-list">
    <div class="desc-list">
      <div v-for="(descItem, index) in value" :key="`desc-${index}`" class="desc-item">
        <div class="desc-input-wrapper">
          <el-input
            v-model="descItem.value"
            :placeholder="`请输入第${index + 1}条描述，5-80个字符`"
            maxlength="80"
            show-word-limit
            clearable
            @input="handleInput"
          />
        </div>
        <span v-if="canDelete" class="remove-icon el-icon-remove" @click="removeDesc(index)"> </span>
      </div>
    </div>

    <div class="add-desc-btn">
      <el-button type="text" icon="el-icon-plus" :disabled="!canAddMore" @click="addDesc"> 添加描述（{{ value.length }}/20） </el-button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { Message } from 'view-design'

// eslint-disable-next-line
const props = defineProps({
  value: {
    type: Array,
    default: () => [{ value: '' }]
  }
})

// eslint-disable-next-line
const emit = defineEmits(['input'])

// 添加描述
const addDesc = () => {
  if (props.value.length >= 20) {
    Message.warning('最多只能添加20条描述')
    return
  }
  const newValue = [...props.value, { value: '' }]
  emit('input', newValue)
}

// 删除描述
const removeDesc = (index) => {
  const newValue = [...props.value]
  newValue.splice(index, 1)
  emit('input', newValue)
}

// 处理输入变化
const handleInput = () => {
  emit('input', props.value)
}

// 计算属性：是否可以添加更多描述
const canAddMore = computed(() => {
  return props.value.length < 20
})

// 计算属性：是否可以删除描述
const canDelete = computed(() => {
  return props.value.length > 1
})
</script>

<style lang="scss" scoped>
.saerch-ad-description-list {
  .desc-list {
    .desc-item {
      display: flex;
      align-items: center;
      margin-bottom: 9px;

      .desc-input-wrapper {
        flex: 1;

        .el-input {
          width: 100%;
        }
      }

      .remove-icon {
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }

  .add-desc-btn {
    .el-button {
      padding: 0;
    }
  }
}
</style>
